import { Outlet, createFileRoute } from '@tanstack/react-router'
import { onlineManager } from '@tanstack/react-query'
import {
  getMyBookingsQueryOptions,
  getTabListQueryOptions,
} from '@/queries/query'
import { queryKeys } from '@/queries/keys'
import { MyBookingListSearchSchema } from '@/schemas/page'
import MyBookingsPage from '@/components/my-booking/List'
import { BOOKING_STATUS } from '@/utils/constant'
import {
  getRefundedCountQueryOptions,
  getRefundedsQueryOptions,
} from '@/queries/query/refunded'

export const Route = createFileRoute('/my-booking/list')({
  validateSearch: MyBookingListSearchSchema,
  loaderDeps: ({ search }) => ({ status: search.tab }),
  loader: ({ context, deps }) => {
    if (onlineManager.isOnline() && !context.isRestoring) {
      return [
        context.queryClient.ensureQueryData(getRefundedCountQueryOptions()),
        context.queryClient.ensureQueryData(getTabListQueryOptions()),
        ...(deps.status === BOOKING_STATUS.REFUNDED
          ? [
              context.queryClient.ensureInfiniteQueryData(
                getRefundedsQueryOptions(),
              ),
            ]
          : [
              context.queryClient.ensureInfiniteQueryData(
                getMyBookingsQueryOptions(deps),
              ),
            ]),
      ]
    }
    return [
      context.queryClient.getQueryData(queryKeys.refunded.count()),
      context.queryClient.getQueryData(queryKeys.myBooking.tabList()),
      ...(deps.status === BOOKING_STATUS.REFUNDED
        ? [context.queryClient.getQueryData(queryKeys.refunded.list())]
        : [context.queryClient.getQueryData(queryKeys.myBooking.list(deps))]),
    ]
  },
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <>
      <MyBookingsPage />
      <Outlet />
    </>
  )
}
